import React, { Component } from 'react';
import _ from 'lodash';
import {isImage, isVideo} from "../../extensions";

import { MediaAttachment } from "../../../../../components/uploadgallery/MediaAttachment";
import { observer } from "mobx-react";
import { PostEditorFormFields } from "./formShapes";


export default observer(class PostMediaAttachments extends Component {

  static propTypes = PostEditorFormFields;

  renderAttachmentsLabel = () => {
    const { values } = this.props;
    if (!values.attachments || values.attachments.length === 0) return undefined;
    return <h5 className="mt-4"><span className="far fa-paperclip"/> Attachments:</h5>;
  }

  renderRemoveLink = (attachment, index) => {
    const { values, onChangeSetObject, mode } = this.props;
    if (mode === "view") return undefined;
    return (
      <div className="text-danger text-right clickable">
        <a onClick={() => onChangeSetObject({attachments: _.filter(values.attachments, (x, i) => i !== index)})}>Remove</a>
      </div>
    );
  }

  renderMediaOrLink = (attachment) => {
    const imageStyle = { maxWidth: '100%', border: '1px solid #EEE', padding: 5 };

    if (attachment.attachmentType === 'Image' || attachment.attachmentType === 'Video') {
      return <MediaAttachment src={attachment.url} imageStyle={imageStyle} />
    } else {
      return (
        <div>
          <div>
            <a className="text-break" href={attachment.url} target="_blank">{attachment.url}</a>
          </div>
          {
            isImage(attachment.url) || isVideo(attachment.url)
              ? <MediaAttachment src={attachment.url} imageStyle={imageStyle} />
              : undefined
          }
        </div>
      );
    }
  }

  renderAttachments = () => {
    const { values } = this.props;
    if (!values.attachments || values.attachments.length === 0) return undefined;

    return (
      values.attachments.map((attachment, index) => {
        return (
          <div className="w-20">
            { this.renderRemoveLink(attachment, index) }
            <div className="w-100 m-2">
              { this.renderMediaOrLink(attachment) }
            </div>
          </div>
        );
      })
    );
  }

  render() {
    return (
      <div className="d-flex flex-column w-100">
        { this.renderAttachmentsLabel() }
        <div className="d-flex flex-wrap p-2 justify-content-between">
          { this.renderAttachments() }
        </div>
      </div>
    );
  }

});
